<section data-test="projectReadme" *ngIf="readme" markdown>
    {{ readme }}
  </section>